import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faEnvelope,
  faMobileAlt,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ServiceFour from "../assets/service-4.png";
import ContactSection from "../common/ContactAs";
import NavigationBar from "../common/NavigationBar";


const GetInTouch = () => {
  return (
    <div id="get-in-touch" className="touch-container">
      <div className="touch-top-bar">
        <NavigationBar />
      </div>
      <div className="newcontact-container">
        <span className="newcontact-subtitle">CONTACT US</span>
        <div className="newcontact-left-section">
          <div className="contact-grid">
            <div className="contact-card">
              <div className="card-row">
                <div className="card-content">
                  <p>SM Gardenia, Flat No-203, Varthur, Bangalore – 560087</p>
                  <a
                    href="https://maps.app.goo.gl/WWEnwMV72ASqyV6R9"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="newcontact-link"
                  >
                    SEE MAP →
                  </a>
                </div>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="newcontact-icon"
                />
              </div>
            </div>

            <div className="contact-card">
              <div className="card-row">
                <div className="card-content">
                  <p>support@rightlender.in</p>
                  <a
                    href="mailto:support@rightlender.in"
                    className="newcontact-link"
                  >
                    SAY HELLO →
                  </a>
                </div>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="newcontact-icon"
                />
              </div>
            </div>

            <div className="contact-card">
              <div className="card-row">
                <div className="card-content">
                  <p>93632 58303</p>
                  <a href="tel:+918610325366" className="newcontact-link">
                    CALL NOW →
                  </a>
                </div>
                <FontAwesomeIcon
                  icon={faMobileAlt}
                  className="newcontact-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ContactSection />
    </div>
  );
};

export default GetInTouch;
